import { backendApi } from "./backend.api";
import { IStatus } from "shared/models/models";

interface listQuery {
  entity: "Order" | "Visit" | "Service" | "Location";
}

export const statusApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    status: build.query<IStatus[], listQuery>({
      query: (queryParams) => ({
        url: "/status",
        method: "GET",
        params: queryParams,
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Status" as const, id })),
              "Status",
            ]
          : ["Status"],
    }),
    getStatus: build.query<IStatus, number>({
      query: (id) => ({ url: `/status/${id}`, method: "GET" }),
      transformErrorResponse: (response: { status: string | number }) =>
        response.status,
      providesTags: (item) => [{ type: "Status", id: item?.id }],
    }),
    addStatus: build.mutation<IStatus, Partial<IStatus>>({
      query: (payload) => ({
        url: "/status",
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["Status"],
      transformResponse: (response: { data: IStatus }) => response.data,
    }),
    updateStatus: build.mutation<IStatus, Partial<IStatus>>({
      query: (payload) => ({
        url: `/status/${payload.id}`,
        method: "PATCH",
        data: payload,
      }),
      invalidatesTags: (item) => [{ type: "Status", id: item?.id }],
    }),
    deleteStatus: build.mutation<IStatus, number>({
      query: (id) => ({
        url: `/status/${id}`,
        method: "DELETE",
        credentials: "include",
      }),
      invalidatesTags: ["Status"],
    }),
  }),
});

export const {
  useStatusQuery,
  useAddStatusMutation,
  useDeleteStatusMutation,
  useGetStatusQuery,
  useUpdateStatusMutation,
} = statusApi;
